/**
 * Error Code Registry
 *
 * Maps consumer contexts to numeric ranges. Each consumer gets one or more
 * specific codes. Users see "An error occurred — XXXXX" — support traces
 * the code back to the exact operation that failed.
 *
 * Ranges:
 *   useOrganization      10001–10009
 *   FinancialSettings    10010–10019
 *   UserSettings         10020–10029
 *   IntegrationSettings  10030–10039
 *   OrganizationMembers  10040–10049
 *   AcceptInvitation     10050–10059
 *   InviteMemberDialog   10060–10069
 *   Dashboard            10070–10079
 *   Transactions         10080–10089
 *   Reconciliation       10090–10099
 *   TrialBalance         10100–10109
 *   TaxCodes             10110–10119
 *   GFICodes             10120–10129
 *   Journal              10130–10139
 *   BankAccounts         10130–10139
 *   Accounts             10140–10149
 *   AccountDetail        10150–10159
 *   InventoryValuation   10160–10169
 *   TaxSummary           10170–10179
 *   ProfitLoss           10180–10189
 *   BalanceSheet         10190–10199
 *   Generic/unknown      19999
 */

export const ErrorCode = {
  // useOrganization
  FETCH_ORGANIZATIONS: 10001,
  CREATE_ORGANIZATION: 10002,
  UPDATE_ORGANIZATION: 10003,

  // FinancialSettings
  SAVE_FINANCIAL_SETTINGS: 10010,

  // UserSettings
  FETCH_PROFILE: 10020,
  SAVE_DISPLAY_NAME: 10021,
  CHANGE_EMAIL: 10022,

  // IntegrationSettings
  FETCH_CONNECTION: 10030,
  DISCONNECT_CONNECTION: 10031,

  // OrganizationMembers
  FETCH_MEMBERS: 10040,
  REMOVE_MEMBER: 10041,
  CHANGE_MEMBER_ROLE: 10042,
  REVOKE_INVITATION: 10043,
  RESEND_INVITATION: 10044,

  // AcceptInvitation
  FETCH_INVITATION: 10050,
  ACCEPT_INVITATION: 10051,

  // InviteMemberDialog
  INVITE_MEMBER: 10060,

  // Dashboard
  FETCH_DASHBOARD: 10070,

  // Transactions
  FETCH_TRANSACTIONS: 10080,

  // Reconciliation
  FETCH_RECONCILIATION: 10090,

  // TrialBalance
  FETCH_TRIAL_BALANCE: 10100,

  // TaxCodes
  FETCH_TAX_CODES: 10110,

  // GFICodes
  FETCH_GFI_CODES: 10120,

  // Journal
  FETCH_JOURNAL: 10130,

  // BankAccounts
  FETCH_BANK_ACCOUNTS: 10140,

  // Accounts
  FETCH_ACCOUNTS: 10150,

  // AccountDetail
  FETCH_ACCOUNT: 10160,
  UPDATE_ACCOUNT: 10161,

  // InventoryValuation
  FETCH_INVENTORY_VALUATION: 10170,

  // TaxSummary
  FETCH_TAX_SUMMARY: 10180,

  // ProfitLoss
  FETCH_PROFIT_LOSS: 10190,

  // BalanceSheet
  FETCH_BALANCE_SHEET: 10200,

  // AuditLog
  FETCH_AUDIT_LOG: 10210,
  EXPORT_AUDIT_LOG: 10211,

  // Generic
  UNKNOWN: 19999,
} as const;

export type ErrorCodeValue = (typeof ErrorCode)[keyof typeof ErrorCode];

export function userMessage(code: ErrorCodeValue): string {
  return `An error occurred \u2014 ${code}`;
}
